<template>
  <div class="account-cert">
    <div class="step2" v-if="step == 2">
      <div class="upload-area">
        <p>
          请保证头像与身份证是同一人，平台对个人身份信息审核。
          <span>请上传正装职业照，可提升通过率！</span>
        </p>
        <div class="upload-img">
          <van-uploader :after-read="onReadZy">
            <img v-if="!avatarUrl" src="./img/zyz.png" alt />
            <img v-if="avatarUrl" :src="avatarUrl" alt />
          </van-uploader>
        </div>
      </div>
      <div class="upload-demo">
        <img src="./img/rw.png" alt />
      </div>
      <div class="btns">
        <van-button type="primary" @click="nextStep">下一步</van-button>
      </div>
    </div>

    <div class="step3" v-if="step == 3">
      <div class="upload-area">
        <p>请保证头像与身份证是同一人，平台对个人身份信息审核。</p>
        <div class="upload-img">
          <van-uploader :after-read="onReadSf">
            <img v-if="!idCardFrontUrl" src="./img/sf.png" alt />
            <img v-if="idCardFrontUrl" :src="idCardFrontUrl" alt />
          </van-uploader>
        </div>
      </div>
      <div style="margin-top:10px;">
        <van-cell-group>
          <van-field v-model="certForm.realName" label="姓名" placeholder="请输入姓名" />
          <van-field v-model="certForm.idNumber" label="身份证号" placeholder="请输入身份证号" />
        </van-cell-group>
      </div>
      <div class="upload-demo">
        <img src="./img/sfz.png" alt />
      </div>
      <div class="btns">
        <van-button type="primary" @click="nextStep">完成提交</van-button>
      </div>
    </div>

    <div class="step4" v-if="step == 4">
      <div class="apply-info">
        <img src="./img/ok.png" alt />
        <h4>提交成功</h4>
        <p>您的个人信息实名申请正在审核中，请耐心等待</p>
      </div>
      <div class="btns">
        <van-button type="primary" @click="submit">确认</van-button>
      </div>
    </div>
    <div class="step4" v-if="step == 5">
      <div class="apply-info">
        <img src="./img/ok.png" alt />
        <h4>审核未通过</h4>
        <p>您的个人信息实名申请未通过，请重试</p>
      </div>
      <div class="btns">
        <van-button type="primary" @click="step = 2">确认</van-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.account-cert {
  // 隐藏最上方1px边框
  margin-top: -1px;
  padding-bottom: 30px;
  .pic-code,
  .tel-code {
    position: relative;
    img {
      position: relative;
      top: -2px;
      right: 5px;
      display: inline-block;
      width: 50px;
      height: 28px;
      background: #f5f5f5;
    }
    span {
      color: #22baa5;
      font-size: 14px;
    }
  }
  .reg-tips {
    color: #666;
    span {
      color: #22baa5;
    }
  }
  .step2,
  .step3 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    .upload-area {
      padding: 15px;
      background: #fff;
      p {
        span {
          color: #f00;
        }
      }
      .upload-img {
        width: 58%;
        margin: 20px auto;
        img {
          width: 100%;
        }
      }
    }
    .upload-demo {
      width: 100%;
      margin-top: 10px;
      img {
        width: 100%;
      }
      padding-bottom: 75px;
    }
    .btns {
      position: fixed;
      background: #fff;
      padding: 10px 15px;
      width: 100%;
      bottom: 0;
    }
  }
  .step4 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;
    .apply-info {
      img {
        width: 75px;
        margin: 35px auto;
        display: block;
      }
      h4 {
        font-size: 18px;
        line-height: 20px;
        text-align: center;
      }
      p {
        text-align: center;
        color: #666;
        margin-top: 10px;
      }
    }
    .btns {
      margin-top: 35px;
    }
  }

  .btns {
    .van-button {
      width: 100%;
      font-size: 16px;
    }
    padding: 0 15px;
    margin-top: 20px;
  }

  .pop-up-wrap {
    height: 100%;
    overflow: auto;
    .pop-inner {
      background: #fff;
      padding-bottom: 55px;
    }
    .pop-btn {
      position: absolute;
      bottom: 0;
      height: 50px;
      line-height: 45px;
      background: #fff;
      width: 100%;
      border-top: 5px solid #f5f5f5;
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>
<style lang="scss">
.account-cert {
  .van-cell-group {
    input {
      font-size: 16px;
    }
  }
  .van-field {
    padding-top: 15px;
    span {
      font-size: 16px;
    }
  }
  .agreement-pop {
    height: 60%;
    background: #f5f5f5;
  }
}
</style>
<script>
import { range } from "@/common/utils";

import { isMobile, isEmail } from "@/common/utils";

import {
  uploadAvatar,
  getUserAuthenticationView,
  addOrUpdateUserAuthenticationFile,
  saveUserAuthenticationInfo
} from "@/api/account";

import md5 from "md5";

// 若是root注册 不显示邀请码，手机号不能改 isroot && mobile
export default {
  name: "account-cert-module",
  data() {
    return {
      step: 2,
      status:this.$route.query.status || '',
      avatarUrl:'',
      idCardFrontUrl:'',
      certForm: {
          realName:"",
          idNumber:"",
            idCardFrontUrl: "", //身份证正面
            avatarUrl: "", //职业照
      }
    };
  },
  watch: {
  },
  components: {},
  methods: {
    onReadSf(file) {
      let params = new FormData(); //创建form对象
      params.append("idCardFrontFile", file.file); //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
      addOrUpdateUserAuthenticationFile(params)
        .then(res => {
          console.log(res);
          this.certForm.idCardFrontUrl = res.data.url;
          this.idCardFrontUrl = res.data.remoteUrl;
        })
        .catch(err => {});
    },
    onReadZy(file) {
      let params = new FormData(); //创建form对象
      params.append("file", file.file); //通过append向form对象添加数据//第一个参数字符串可以填任意命名，第二个根据对象属性来找到file
      uploadAvatar(params)
        .then(res => {
          console.log(res);
          this.certForm.avatarUrl = res.data.url;
          this.avatarUrl = res.data.remoteUrl;
          // this.certForm.legalPersonID = res.data.remoteUrl;
          // this.certForm.legalPersonAttachment = res.data.url;
        })
        .catch(err => {});
    },
    submit() {
        if(WeixinJSBridge){
          WeixinJSBridge.call('closeWindow');
        }else{
          window.close();
        };
    },
    nextStep() {
        if(this.step == 2){
            if(!this.certForm.avatarUrl){
                this.$toast('请上传职业照');
                return;
            };
            this.step ++ ;
        }else if(this.step == 3){
            if(!this.certForm.idCardFrontUrl){
                this.$toast('请上传身份证');
                return;
            };
            if(!this.certForm.realName.trim()){
                this.$toast('请填写姓名');
                return;
            };
            if(!this.certForm.idNumber.trim()){
                this.$toast('请填写身份证号');
                return;
            };
            if(this.certForm.idNumber.trim().length != 18 || !/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/.test(this.certForm.idNumber.trim())){
                this.$toast('身份证格式不正确');
                return;
            };

            saveUserAuthenticationInfo(this.certForm).then(res=>{
                this.step ++;
            }).catch(err => {

            });

        }
    }
  },
  created() {
      if(!this.status){
          this.step = 2;
          // 未认证
      };
      if(this.status == 1){
          this.step = 4;
          // 申请中
      };
      if(this.status == 3){
          this.step = 5; 
          // 拒绝
      };
  }
};
</script>
